export var handleCost = function handleCost() {
  var mods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var counterChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var initalCost = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var setCost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return "";
  };
  //Reduce all cost elements into one to display
  // TODO :: follow up with max to make sure this has no side effects
  var value = (Array.isArray(mods) ? mods : []).reduce(function (prev, next) {
    var _next$selectedOptions;

    // var value = mods.reduce(function (prev,next) {
    return prev + (next === null || next === void 0 ? void 0 : (_next$selectedOptions = next.selectedOptions) === null || _next$selectedOptions === void 0 ? void 0 : _next$selectedOptions.reduce(function (prev, next) {
      var cost;

      try {
        cost = parseFloat(next === null || next === void 0 ? void 0 : next.cost) || 0;
      } catch (_unused) {
        cost = 0;
      }

      return prev + cost;
    }, 0)) || 0;
  }, 0);
  var total = (value + initalCost) * counterChild;
  setCost(total.toFixed(2));
  return total.toFixed(2);
};